module.exports = __webpack_public_path__ + "static/media/ic_error_toastr.af432d4d.svg";